import { createContext } from "react";

const oportunitiesContext = createContext();

export default oportunitiesContext;
